import type { PrecioItem, ReservaItem } from '../services/landing/cotizacionService';
import { finCotizacion } from './quotationDates';

export const boliviaToday = (now = new Date()): string => {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/La_Paz', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const value = (type: string) => parts.find(part => part.type === type)?.value || '';
    return `${value('year')}-${value('month')}-${value('day')}`;
};

export const timeMinutes = (value: string): number => {
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
};

export const quotationEnd = (start: string, price: PrecioItem | null, periods: number): string => {
    const duration = (price?.horas || 1) * (price?.dias || price?.unidad === 'dia' ? 1 : periods) * 60;
    const total = timeMinutes(start) + duration;
    if (!Number.isFinite(total) || total >= 1440) return '';
    return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
};

export const quotationDays = (starts: string[], price: PrecioItem | null, periods: number, business = false): string[] => {
    const days = new Set<string>();
    for (const start of starts) {
        const end = finCotizacion(start, price?.dias || 1, price?.dias || price?.unidad === 'dia' ? periods : 1, business);
        const cursor = new Date(`${start}T12:00:00`);
        if (Number.isNaN(cursor.getTime())) continue;
        while (true) {
            const day = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}-${String(cursor.getDate()).padStart(2, '0')}`;
            if (day > end) break;
            if (!business || ![0, 6].includes(cursor.getDay())) days.add(day);
            cursor.setDate(cursor.getDate() + 1);
        }
    }
    return Array.from(days).sort();
};

export const reservationsOnDate = (date: string, reservations: ReservaItem[]): ReservaItem[] =>
    reservations.filter(reservation => date >= reservation.fecha_inicio && date <= (reservation.fecha_fin || reservation.fecha_inicio) &&
        (!reservation.dias_habiles || ![0, 6].includes(new Date(`${date}T12:00:00`).getDay())));

export const occupiedInterval = (dates: string[], start: string, end: string, reservations: ReservaItem[]): boolean =>
    dates.some(date => reservationsOnDate(date, reservations).some(reservation =>
        (!reservation.hora_inicio || !reservation.hora_fin || (start < reservation.hora_fin.slice(0, 5) && end > reservation.hora_inicio.slice(0, 5)))));

export const numericDate = (value: string): string => value.split('-').reverse().join('/');
